/** Native cart links stay usable when cart enhancement is unavailable. */
class SRukiaHeader extends HTMLElement {
  #controller;

  connectedCallback() {
    this.#controller?.abort();
    this.#controller = new AbortController();
    this.addEventListener('click', (event) => {
      const link = event.target.closest?.('a[data-cart-link]');
      if (!link || !this.contains(link) || event.defaultPrevented || event.button !== 0
        || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      // Keep ordinary navigation until the drawer and cart enhancement both exist.
      const dialog = this.querySelector('dialog#cart-drawer');
      if (!dialog || typeof dialog.showModal !== 'function'
        || !customElements.get('s-dialog') || !customElements.get('s-cart')) return;

      try {
        link.focus({ preventScroll: true });
        if (!dialog.open) dialog.showModal();
        event.preventDefault();
      } catch {
        // A failed enhancement must never leave a shopper without a cart link.
      }
    }, { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }
}

if (!customElements.get('s-rukia-header')) customElements.define('s-rukia-header', SRukiaHeader);
